import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Pipe para traducir textos dinámicos que vienen del backend
 * Uso: {{ texto | dynamicTranslate }}
 * Ejemplo: {{ plan.name_plan | dynamicTranslate }}
 * 
 * Si encuentra traducción en i18n, la usa. Si no, devuelve el texto original.
 */
@Pipe({
  name: 'dynamicTranslate',
  standalone: true,
  pure: false
})
export class DynamicTranslatePipe implements PipeTransform {
  
  constructor(private translate: TranslateService) {}

  transform(value: string): string {
    // Si no hay valor, retornar vacío
    if (!value) {
      return '';
    }

    const currentLang = this.translate.currentLang || 'es';
    
    // Si el idioma es español, retornar el texto original sin traducir
    if (currentLang === 'es') {
      return value;
    }

    // Intentar buscar primero en el objeto frequencies
    const frequencyTranslation = this.translate.instant(`frequencies.${value}`);
    if (frequencyTranslation !== `frequencies.${value}`) {
      return frequencyTranslation;
    }

    // Si no está en frequencies, buscar a nivel raíz
    const translation = this.translate.instant(value);
    if (translation !== value) {
      return translation;
    }
    
    // Si no hay traducción, retornar el texto original
    return value;
  }
}
